import { Enum } from '@utils/enum';

export const types = Enum('normal', 'hero-tight');
